import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClienteFichaComponent } from './central-cliente-ficha.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: CentralClienteFichaComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClienteFichaRoutingModule { }
